export interface ViewState {
  center: [number, number];
  zoom: number;
  rotation: number;
  timestamp: Date;
  heading?: number;
  tilt?: number;
  altitude?: number;
}

export class ViewHistory {
  private history: ViewState[] = [];
  private currentIndex = -1;
  private maxSize: number;
  private isNavigating = false;

  constructor(maxSize = 50) {
    this.maxSize = maxSize;
  }

  push(state: ViewState): void {
    if (this.isNavigating) return;

    if (this.currentIndex < this.history.length - 1) {
      this.history = this.history.slice(0, this.currentIndex + 1);
    }

    const last = this.history[this.history.length - 1];
    if (last && Math.abs(last.center[0] - state.center[0]) < 0.0001 &&
        Math.abs(last.center[1] - state.center[1]) < 0.0001 &&
        Math.abs(last.zoom - state.zoom) < 0.1) {
      return;
    }

    this.history.push({ ...state, timestamp: new Date() });
    if (this.history.length > this.maxSize) {
      this.history.shift();
    }
    this.currentIndex = this.history.length - 1;
  }

  canUndo(): boolean {
    return this.currentIndex > 0;
  }

  canRedo(): boolean {
    return this.currentIndex < this.history.length - 1;
  }

  undo(): ViewState | null {
    if (!this.canUndo()) return null;
    this.isNavigating = true;
    this.currentIndex--;
    const state = this.history[this.currentIndex];
    setTimeout(() => { this.isNavigating = false; }, 500);
    return state || null;
  }

  redo(): ViewState | null {
    if (!this.canRedo()) return null;
    this.isNavigating = true;
    this.currentIndex++;
    const state = this.history[this.currentIndex];
    setTimeout(() => { this.isNavigating = false; }, 500);
    return state || null;
  }

  getHistory(): ViewState[] {
    return [...this.history];
  }

  getCurrent(): ViewState | null {
    return this.history[this.currentIndex] || null;
  }

  clear(): void {
    this.history = [];
    this.currentIndex = -1;
  }

  get size(): number {
    return this.history.length;
  }
}
